
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns93de3299239791191f7280c9824ebdfden from './en.yaml'
            i18n.addResourceBundle('en', '93de3299239791191f7280c9824ebdfd', flattenObject(ns93de3299239791191f7280c9824ebdfden), true, true);
        
        export default '93de3299239791191f7280c9824ebdfd';
    